import * as React from 'react'

function SvgIdea(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g id="idea">
        <g id="Group">
          <path
            id="Vector"
            d="M19.545 10.0028C18.1507 8.68145 16.2678 8.00271 14.3511 8.1305C10.6826 8.35205 7.80886 11.3708 7.768 15.0457C7.73783 17.6729 9.33825 20.0585 11.4521 21.2362V24.6787C11.4521 26.5132 12.9393 28.0004 14.7738 28.0004C16.6083 28.0004 18.0955 26.5132 18.0955 24.6787V21.2664C20.326 19.9936 21.7246 17.6434 21.7796 15.0759C21.7534 13.1519 20.9469 11.3209 19.545 10.0028ZM14.7738 26.7322C13.7541 26.6869 12.9077 25.9289 12.7506 24.9203H16.797C16.6399 25.9289 15.7936 26.6868 14.7738 26.7322ZM16.8877 23.7124H12.66V22.8065H16.8877V23.7124ZM17.1896 20.3303C16.9963 20.4418 16.8802 20.6508 16.8877 20.8739V21.5986H12.66V20.8739C12.6721 20.6418 12.5563 20.4216 12.3581 20.3001C10.2862 19.3931 8.95544 17.3375 8.97596 15.0759C9.03058 12.0452 11.3882 9.55666 14.4115 9.33841H14.7739C17.9458 9.35447 20.5225 11.9043 20.5718 15.0759C20.573 17.3393 19.2503 19.3941 17.1896 20.3303Z"
            fill="black"
          />
          <path
            id="Vector_2"
            d="M14.7739 6.4692C15.1074 6.4692 15.3778 6.19881 15.3778 5.86525V2.60395C15.3778 2.27039 15.1074 2 14.7739 2C14.4403 2 14.1699 2.27039 14.1699 2.60395V5.86525C14.1699 6.19881 14.4403 6.4692 14.7739 6.4692Z"
            fill="#4EC677"
          />
          <path
            id="Vector_3"
            d="M5.86531 14.0488H2.60395C2.27039 14.0488 2 14.3192 2 14.6528C2 14.9863 2.27039 15.2567 2.60395 15.2567H5.86525C6.19881 15.2567 6.4692 14.9863 6.4692 14.6528C6.4692 14.3192 6.19887 14.0488 5.86531 14.0488Z"
            fill="#4EC677"
          />
          <path
            id="Vector_4"
            d="M26.9434 14.0488H23.6821C23.3485 14.0488 23.0781 14.3192 23.0781 14.6528C23.0781 14.9863 23.3485 15.2567 23.6821 15.2567H26.9434C27.2769 15.2567 27.5473 14.9863 27.5473 14.6528C27.5473 14.3192 27.2769 14.0488 26.9434 14.0488Z"
            fill="#4EC677"
          />
          <path
            id="Vector_5"
            d="M5.74455 6.59102L8.06978 8.88602C8.28398 9.11954 8.64697 9.13514 8.88042 8.92088C8.89256 8.90978 8.90418 8.8981 8.91527 8.88602C9.14879 8.67182 9.16439 8.30883 8.95013 8.07538C8.93903 8.06324 8.92735 8.05162 8.91527 8.04053L6.5901 5.74552C6.39 5.47866 6.01141 5.42462 5.74455 5.62472C5.47768 5.82482 5.42364 6.20341 5.62374 6.47028C5.65808 6.516 5.69877 6.55669 5.74455 6.59102Z"
            fill="#4EC677"
          />
          <path
            id="Vector_6"
            d="M20.6322 8.88412C20.7437 8.99793 20.8957 9.06301 21.055 9.06533C21.2143 9.06307 21.3662 8.99793 21.4777 8.88412L23.8029 6.58912C24.0698 6.38902 24.1238 6.01043 23.9237 5.74357C23.7236 5.47671 23.345 5.42267 23.0782 5.62277C23.0324 5.6571 22.9917 5.69779 22.9574 5.74357L20.6322 8.03857C20.3987 8.25278 20.383 8.61576 20.5973 8.84921C20.6085 8.86141 20.6201 8.87303 20.6322 8.88412Z"
            fill="#4EC677"
          />
        </g>
      </g>
    </svg>
  )
}

export default SvgIdea
